import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 474 474" {...props}>
      <title id="Bar-Chart">{props.title || 'Bar-Chart'}</title>
      <g>
        <title>bar-chart 2</title>
        <path d="M126.76 266.89v93.5h-62.2v-93.5h62.2zm93.39-124.62v218.12h-62.2v-218.12h62.2zm93.45 62.34v155.78h-62.26v-155.78h62.26zm93.4-93.51v249.29h-62.21v-249.29h62.21zm31.07 272.72v-296.09c0-2.13-.73-3.98-2.3-5.44-1.56-1.57-3.41-2.3-5.43-2.3h-389.19c-2.12 0-3.97.73-5.43 2.3-1.45 1.57-2.29 3.42-2.29 5.44v295.98c0 2.13.72 3.98 2.29 5.44 1.57 1.46 3.42 2.3 5.43 2.3h389.08c2.13 0 3.98-.73 5.43-2.3 1.68-1.46 2.41-3.25 2.41-5.33zm31.13-296.09v295.98c0 10.71-3.75 19.9-11.42 27.52-7.62 7.68-16.74 11.44-27.49 11.44h-389.14c-10.69 0-19.87-3.76-27.49-11.44-7.67-7.62-11.42-16.76-11.42-27.52v-295.98c0-10.71 3.75-19.9 11.42-27.52 7.62-7.68 16.74-11.44 27.49-11.44h389.08c10.7 0 19.88 3.76 27.49 11.44 7.73 7.62 11.48 16.81 11.48 27.52z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/barChart.js